import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import PurchaseSection from './components/PurchaseSection';
import {
  getStockPurchases,
  getBeSpokePurchases,
  exportBeSpokePurchases,
  exportStockPurchases
} from 'services/purchasing-history/purchasingHistoryService';
const PurchasingHistory = () => {
  return (
    <>
      <PageHeader
        title="Purchasing History"
        description="View supplier purchasing history"
        className="mb-3"
      />

      <Row className="g-3">
        <Col lg={12}>
          <Card body>
            <PurchaseSection
              title="Stock Purchases"
              fetchApi={getStockPurchases}
              exportApi={exportStockPurchases}
            />

            <PurchaseSection
              title="Bespoke Purchases"
              fetchApi={getBeSpokePurchases}
              exportApi={exportBeSpokePurchases}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PurchasingHistory;
